module.exports = __webpack_public_path__ + "static/404-Error-Page-MB-pup_03-5cc928a084cd896daa5403e8b3a74da9.png";